import React from 'react';
import HeaderOne from '../common/header/HeaderOne';
import FooterOne from '../common/footer/FooterOne';
import Breadcrumb from '../common/breadcrumb/Breadcrumb';
import { ComparisonTable } from '@/components/comparison';
import { useComparison } from '@/hooks/use-comparison';

const Compare: React.FC = () => {
  const {
    count,
    clearItems,
    getComparisonTableData,
  } = useComparison();

  const tableData = React.useMemo(() => getComparisonTableData(), [getComparisonTableData]);

  return (
    <>
      <HeaderOne />
      <Breadcrumb
        title="Compare Vendors"
        currentPage="Compare"
        img="/assets/images/backgrounds/breadcrumb-bg.jpg"
      />

      <section className="py-12 bg-cream">
        <div className="container mx-auto px-4">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-bark mb-4">
              Compare Vendors
            </h1>
            <p className="text-muted-foreground">
              Compare up to 4 vendors side-by-side to find the best match for your needs
            </p>
          </div>

          {count === 0 ? (
            <div className="text-center py-16 bg-white rounded-lg shadow-sm">
              <div className="max-w-md mx-auto">
                <div className="text-6xl mb-4">📊</div>
                <h2 className="text-xl font-semibold text-bark mb-2">
                  No Vendors to Compare
                </h2>
                <p className="text-muted-foreground mb-6">
                  Browse our directory and click "Add to Compare" on vendor cards
                  to start comparing farms and markets.
                </p>
                <a
                  href="/browse"
                  className="inline-flex items-center justify-center px-6 py-3 bg-forest text-white font-medium rounded-lg hover:bg-forest-light transition-colors"
                >
                  Browse Vendors
                </a>
              </div>
            </div>
          ) : (
            <>
              <div className="flex justify-between items-center mb-6">
                <p className="text-muted-foreground">
                  Comparing {count} vendor{count !== 1 ? 's' : ''}
                </p>
                <button
                  onClick={clearItems}
                  className="text-sm text-destructive hover:underline"
                >
                  Clear All
                </button>
              </div>

              <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                <ComparisonTable
                  data={tableData}
                />
              </div>
            </>
          )}
        </div>
      </section>

      <FooterOne />
    </>
  );
};

export default Compare;
